<template>
  <v-dialog persistent v-model="dialog" max-width="500px">
    <ExecutionResultsDialog title="Alias Separation" @close="close()" ref="executionResultsDialog" />
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title>
          Remove Alias {{ aliasName }}?
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        The alias <strong>{{ aliasName }}</strong> will be removed from this data source.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" :loading="loading" @click="submit()">
          <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.Remove') }}
        </v-btn>
        <v-btn outline color="secondary" @click="close()" :disabled="loading">
          {{ $t('Button.Cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const dataSources = createNamespacedHelpers('datasource')
  const synonyms = createNamespacedHelpers('synonyms')
  const app = createNamespacedHelpers('app')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  export default {
    data() {
      return {
        alias: null,
        dialog: false,
        loading: false,
      }
    },
    computed: {
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceIndexByType']),
      ...dataSources.mapGetters(['dataSourceIndex']),
      continuousDataSource() {
        return this.currentFeatureDataSourceIndexByType[SOURCE_TYPES.continuousAquarius]
      },
      continuousStationsIndex() {
        return this.dataSourceIndex[SOURCE_TYPES.continuousAquarius] || []
      },
      currentContinuousStation() {
        return this.continuousStationsIndex[this.continuousDataSource.SourceId]
      },
      aliasName() {
        return this.alias && this.alias.Name
      },
    },
    methods: {
      ...dataSources.mapActions(['fetchDataSources']),
      ...synonyms.mapActions(['removeSynonym']),
      ...app.mapActions(['setSnackbar']),
      show(alias) {
        this.alias = alias
        this.dialog = true
      },
      close() {
        this.dialog = false
      },
      async submit() {
        this.loading = true

        try {
          const payload = {
            sourceId: this.currentContinuousStation.Id,
            synonymName: this.alias.Name,
            sourceType: SOURCE_TYPES.continuousAquarius,
            assignToLocation: false,
          }

          let executionResults = await this.removeSynonym(payload)
          this.$refs.executionResultsDialog.show(executionResults)

          await this.fetchDataSources({
            sourceTypes: [SOURCE_TYPES.continuousAquarius],
          })

        } catch (error) {
          console.error(error)
          this.setSnackbar({
            text: error,
            color: 'error',
            icon: 'error',
          })
        }

        this.loading = false
      },
    },
  }
</script>